export default __webpack_public_path__ + "static/media/css-3.34768f26.svg";